import { render, staticRenderFns } from "./TastePanelTable.vue?vue&type=template&id=e8b247c8&"
import script from "./TastePanelTable.vue?vue&type=script&lang=js&"
export * from "./TastePanelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports